import * as React from "react";
import styled from "styled-components";
import { mixinSkins } from "../../../skins/shared/mixins/themeStyles";
import { SkinId } from "../../../skins/types";
import { riotProductStyle } from "../skins/riot-product";
import { ContentEngagement } from "../../../components/ContentEngagement";
import { Card, CardBody, CardDescription, CardImage, CardTitle } from "../../../components/Card";
import { AspectRatio } from "../../../components/AspectRatio";
import { generateContentAnalytics } from "../../../functional/analyticsUtils";
import { Media } from "../../../components/Media/";
import { Icon } from "../../../components/Icon";
import { RelativeFormattedDate } from "../../../components/RelativeFormattedDate/components/RelativeFormattedDate";
import { RichTextSmall } from "../../../components/RichText/specialties/RichTextSmall";
export const ImageContainer = styled.div ``;
export const CardInfo = styled.div ``;
export const CardCategory = styled.div ``;
export const CardDate = styled.div ``;
export const VerticalLine = styled.div ``;
const StylableArticleFeaturedCard = ({ content, ...props }) => {
    const { media, title, action, description, publishedAt, category } = content;
    const className = props.className || "";
    const isWeblinkDownloadAction = action?.type === "weblink" && action?.payload.url.endsWith(".zip");
    const isRegularWeblinkAction = action?.type === "weblink" && !isWeblinkDownloadAction;
    return (React.createElement(ContentEngagement, { contentAnalytics: generateContentAnalytics(content, "ArticleFeatureCard"), action: action, ...props, className: action ? `${className} action` : className },
        React.createElement(Card, null,
            React.createElement(CardImage, { className: "action" },
                React.createElement(AspectRatio, { ratio: 16 / 9 },
                    React.createElement(Media, { media: media }),
                    action?.type === "youtube_video" && React.createElement(Icon, { name: "action-play-video", title: "play video" }),
                    isWeblinkDownloadAction && React.createElement(Icon, { name: "action-download", title: "download" }),
                    isRegularWeblinkAction && React.createElement(Icon, { name: "action-external-link", title: "external link" }),
                    action?.type === "image_viewer" && React.createElement(Icon, { name: "action-image-viewer", title: "image viewer" }),
                    action?.type === "media_viewer" && React.createElement(Icon, { name: "action-image-viewer", title: "media viewer" }))),
            React.createElement(CardBody, null,
                (category || publishedAt) && (React.createElement(CardInfo, null,
                    category && React.createElement(CardCategory, { "data-testid": "card-category" }, category.title),
                    category && publishedAt && React.createElement(VerticalLine, null),
                    publishedAt && (React.createElement(CardDate, { "data-testid": "card-date" },
                        React.createElement(RelativeFormattedDate, { date: publishedAt }))))),
                title && React.createElement(CardTitle, null, title),
                !!description && (React.createElement(CardDescription, { "data-testid": "card-description" },
                    React.createElement(RichTextSmall, { ...description })))))));
};
StylableArticleFeaturedCard.defaultProps = {
    "data-testid": "articlefeaturedcard-component",
};
export const ArticleFeaturedCard = styled(StylableArticleFeaturedCard) `
  ${mixinSkins({
    [SkinId.RiotProduct]: riotProductStyle,
})}
`;
//# sourceMappingURL=ArticleFeaturedCard.js.map